export default {
  methods: {
    resetData() {
      if (typeof this.$options.data !== "undefined") {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
      this.onResetData();
    },

    onResetData() {}
  }
};
